import $ from "jquery"
import Twig from "twig";

export class actual_api {
    url
    constructor(url) {
        this.url = url;
    }

    async Login(username, pass) {
        const path = '/auth/login';
        let result = await $.ajax({
            url: this.url + path,
            data:JSON.stringify({user_name: username, password: pass}),
            format:'json',
            method: 'post'
        });
        /*console.debug(result);*/
        return result;
    }

    WhoIs() {
        const path = '/auth';
        let token = sessionStorage.getItem('token');
        let result;
            $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            method: 'get',
            format:'json',
            async: false,
            success: ((json)=>{
                result = json
            }),
            error: ((error)=>{
                result = error
            }),

        });
        return result
    }
    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            let WhoIs = this.WhoIs();
            if(WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }
    getDoctor(userId) {
        const path = '/auth?id=' + userId;
        let token = sessionStorage.getItem('token');
        let result;
             $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            method: 'get',
            format:'json',
         async: false,
         success: ((json)=>{
             result = json
         }),
         error: ((error)=>{
             result = error
         }),
        });
        return result;
    }

    async setPass(username, password){
        const path = '/auth/set/password';
      /*  console.debug(username);
        console.debug(password);*/
        let result = await $.ajax({
            url: this.url + path,
            contentType: 'application/json',
            data:JSON.stringify({user_name: username, password: password}),
            dataType:'json',
            type: 'post'
        });

        return result;
    }

    getAnketa(id){
        const path = '/patient/profile?id='+ id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json
            })
        });

        return result;
    }

    async createAnketa(json){
       const path = '/patient';
       let token = sessionStorage.getItem('token');
        let result = await $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            data: JSON.stringify(json),
            format:'json',
            method: 'post',
            contentType: "application/json"
        });
        return result;
    }

    async deleteAnketa(id){
       const path = '/patient/profile?id='+ id;
       let token = sessionStorage.getItem('token');
       let result;
       $.ajax({
           url: this.url + path,
           headers: {'Authorization': 'Bearer '+ token },
           format:'json',
           method: 'delete',
           async: false,
           success: ((json)=>{
               result = json
           })
       });
       return result;
    }

    async deletePatient(id){
        const path = '/patient/patient?id='+ id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'delete',
            async: false,
            success: ((json)=>{
                result = json
            })
        });
        return result;
    }

    /*
    передавать в doctorList тип
    * /auth/user/list/all
    * /auth/user/list/doctor
    * /auth/user/list/manager
    * */

    _doctorListCache = {};

    doctorList(type) {
        if (this._doctorListCache[type]) {
            return this._doctorListCache[type];
        }

        const path = '/auth/user/list/' + type;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer ' + token},
            format: 'json',
            method: 'get',
            async: false,
            success: ((json) => {
                result = json;
                this._doctorListCache[type] = json;
            })
        });
        return result;
    }


    profileList(id){
        const path = '/patient/profiles/list?id='+ id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json
            }),
            error: (()=>{
                result = null
            }),
        });
        return result;
    }


    searchClient(phone){
        const path = '/client?phone='+ phone;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
                result.status = 200
            }),
            error: ((error)=>{
                result = error;
                console.debug(error)
            }),
            timeout: 10000 // sets timeout to 10 seconds
        });

        return result;
    }

    createClient(phone, name, surname){
        const path = '/client';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post',
            async: false,
            data:  JSON.stringify({
                phone: phone,
                name: name,
                surname: surname
            }),

            contentType: "application/json",
            success: ((json)=>{
                result = json
            }),
            error: ((error)=>{
                console.debug(error);
                result = undefined
            }),
        });
        return result;
    }

    statusClient(tokens){
        const path = '/cabinet/'+ tokens;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json
            })
        });
        return result;
    }

    bonusClient(bonus){
        const path = '/cabinet/bonus/'+ bonus;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json
            })
        });
        return result;
    }

    sendMessagePush(json){
        const path = '/admin/push/send'
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post',
            async: false,
            data: json,
            success: ((json)=>{
                result = json;
                console.debug(json);
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    sendMessageWhatsapp(json){
        const path = '/admin/wazzup/send'
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post',
            async: false,
            data: json,
            success: ((json)=>{
                result = json;
                console.debug(json);
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    managerClientCreate(json){
        const path = '/patient/only'
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post',
            async: false,
            data: json,
            success: ((json)=>{
                result = json;
                console.debug(json);
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    getByPhone(phone){
        const path = '/patient/phone/'+phone;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
                console.debug(json);
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    //когда будут все - путь тотже, но не передаем токен
    loadPurchasesSingle(usertoken){
    const path = '/cabinet/load/sales/'+usertoken;
    let token = sessionStorage.getItem('token');

       return $.ajax({
        url: this.url + path,
        headers: {'Authorization': 'Bearer '+ token },
        format:'json',
        method: 'post',
    });
}

    loadNewClients(){
        const path = '/patient/new';
        let token = sessionStorage.getItem('token');

        return $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get'
        });
    }

    loadStatusLoading(){
        const path = '/patient/load/status';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
                //console.debug(json);
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }


    loadAllPurchases(){
        const path = '/cabinet/load/sales';
        let token = sessionStorage.getItem('token');

        return $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post'
        });
    }

    loadAllPurchasesStatusLoading(){
        const path = '/cabinet/load/process';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
                //console.debug(json);
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    blockTime(userdata) {
        const path = '/schedule/occupation/block';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post',
            async: false,
            data:JSON.stringify(userdata),
            success: ((json)=>{
                result = json;
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    isApproved(id) {
        const path = '/schedule/occupation/approve/'+id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    setPrepaid(id, sum) {
        const path = '/schedule/occupation/prepay';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post',
            async: false,
            data:JSON.stringify({
                "Id": Number(id),
                "Amount": Number(sum)
            }),
            success: ((json)=>{
                result = json;
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    salonsList(){
        const path = '/auth/salons/list';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json
            })
        });
        return result;
    }

    getPurchases(id){
        const path = '/cabinet/sales/'+ id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json
            })
        });
        return result;
    }

    getReceiptFromWeb(id){
        const path = '/patient/receipt/'+ id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json
            }),
            error: (()=>{
                result = null
            })
        });
        return result;
    }

    searchPatient(id){
        const path = '/patient/'+ id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            //headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
                result.status = 200
            }),
            error: ((error)=>{
                result = error;
            }),
            timeout: 10000 // sets timeout to 10 seconds
        });

        return result;
    }

    changeOrderServiceList(id,diagnostic) {
        const path = '/schedule/change/diagnostic/'+id+'/'+diagnostic;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    cancelOrder(id, reason) {
        const path = '/schedule/'+id+'/'+reason;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'delete',
            async: false,
            success: ((json)=>{
                result = json;
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    searchAppointment (id){
        const path = '/schedule/'+ id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'get',
            async: false,
            success: ((json)=>{
                result = json;
                result.status = 200
            }),
            error: ((error)=>{
                result = error;
            }),
        });

        return result;
    }

    addAdditionalComment (id,json){
        const path = '/schedule/change/info/'+id;
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            url: this.url + path,
            headers: {'Authorization': 'Bearer '+ token },
            format:'json',
            method: 'post',
            async: false,
            data: json,
            success: ((json)=>{
                result = json;
            }),
            error:  ((error)=>{
                result = null
            }),
        });
        return result;
    }

    /* id = id zapisi */
    searchOrderDoctor(id){
        const path = '/schedule/occupation';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            method: 'post',
            url: this.url + path,
            contentType: "application/json",
            data: JSON.stringify({
                positivId: 82,
                id:        id
            }),
            format:'json',
            dataType: 'json',
            async: false,
            success: function(json){
                result = json;
            },
            error(error){
                console.debug(error)
            }
        })
        return result;
    }

    //проверяем занятость на время и дату
    getOccupation(doctorId,timeFrom,timeTo){
        const path = '/schedule/occupation';
        let token = sessionStorage.getItem('token');
        let result;
        $.ajax({
            method: 'post',
            url: this.url + path,
            contentType: "application/json",
            data: JSON.stringify({
                positivId: "82",
                doctorId:  String(doctorId),
                timeFrom:  String(timeFrom),
                timeTo:  String(timeTo),
            }),
            format:'json',
            dataType: 'json',
            async: false,
            success: function(json){
                result = json;
            },
            error(error){
                console.debug(error)
            }
        })
        return result;
    }

}
